<div #chart class="no-axis-chart small"></div>
